import type { CustomerReferenceWrapperProps } from "@repo/ui/structuredContent/customerReferenceContext";
import type { FC } from "react";
import { appPaths } from "../../app/appPaths.js";
import { usePlaybookIdParam } from "../../hooks/usePlaybookIdParam.js";
import { DEFAULT_PLAYBOOK_URL_SEGMENT } from "../links/defaultPlaybookRedirect.js";

/**
 * Links structured content customer references to the customer's page, in a
 * new tab like teammate references. The page is playbook-scoped: the link uses
 * the playbook the reference resolved to, else the current page's playbook,
 * else the viewer's default playbook. Supplied to the shared renderers via
 * `CustomerReferenceProvider`.
 */
export const CustomerReferenceLinkAdapter: FC<CustomerReferenceWrapperProps> = (
  props,
) => {
  const { reference, className, children } = props;
  const pagePlaybookId = usePlaybookIdParam();
  return (
    <a
      href={appPaths.playbookCustomer.build({
        playbookId:
          reference.playbookId ??
          pagePlaybookId ??
          DEFAULT_PLAYBOOK_URL_SEGMENT,
        accountId: reference.accountId,
      })}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};
